const langMap: Record<string, string> = {
    en: 'en-us',
    pt: 'pt-br',
    zh: 'zh-cn',
    'zh-Hans': 'zh-cn',
    es: 'es',
    de: 'de',
    fr: 'fr',
    it: 'it',
    ja: 'ja',
    nl: 'nl'
}
export const getLocalizedLanguage = (userLang: string): string => {
    return langMap[userLang] || userLang
}
